import { ArrayQ } from "./ArrayQ"
import { NullQ } from "./NullQ"

// Excludes anything iterable (generators, Maps, Sets, ...) in addition to
// arrays — a lazy generator is a plain object with no enumerable own keys, so
// without this a consumer keying off `Object.keys`/`Object.values` (like
// `WaitPromises`) would silently see it as an empty record instead of
// draining its items.
export const RecordQ = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && !NullQ(value) && !ArrayQ(value) && !(Symbol.iterator in value)
